/**
 * Bump this whenever a rate or pricing rule changes. It is included in output
 * fingerprints so a quote generated with an older rate card cannot remain
 * marked as current after a deployment.
 */
export const PRICING_VERSION = '2026-07-14.1';

export const OUTPUT_FINGERPRINT_VERSION = 'bdv-door-v2';
